export const WEB_PAYMENTS_QUERY_PARAMS = {
    state: "state",
    walletCode: "walletCode",
    fromWalletPage: "fromWalletPage",
    selectedturbomethod: "selectedturbomethod",
    orderid: "orderId",
    flowType: "flowType",
    dealId: "dealId",
    isOfferEnabled: "isOfferEnabled",
    imageId: "imageId",
};

export const WEB_FOOD_CART_PAYMENT_CONFIG_STORAGE_KEY = "web_food_cart_payment_config";
